import React from 'react';
import { DatePicker } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import styles from './DateFilterInputs.module.scss';

export interface DateFilterInputsProps {
  fromDate: string;
  toDate: string;
  onFromChange: (date: string) => void;
  onToChange: (date: string) => void;
  disabled?: boolean;
}

export const DateFilterInputs: React.FC<DateFilterInputsProps> = ({ fromDate, toDate, onFromChange, onToChange, disabled = false }) => {
  const handleFromChange = (date: Dayjs | null) => {
    onFromChange(date ? date.format('YYYY-MM-DD') : '');
  };

  const handleToChange = (date: Dayjs | null) => {
    onToChange(date ? date.format('YYYY-MM-DD') : '');
  };

  return (
    <div className={styles.container}>
      <div className={styles.field}>
        <label className={styles.label}>FROM:</label>
        <div className={styles.pickerWrap}>
          <DatePicker
            value={fromDate ? dayjs(fromDate) : null}
            onChange={handleFromChange}
            disabled={disabled}
            format="YYYY-MM-DD"
            placeholder="DATE"
            suffixIcon={null}
            disabledDate={(current) => current && (current > dayjs().endOf('day') || (toDate ? current > dayjs(toDate) : false))}
          />
        </div>
      </div>
      <div className={styles.field}>
        <label className={styles.label}>TO:</label>
        <div className={styles.pickerWrap}>
          <DatePicker
            value={toDate ? dayjs(toDate) : null}
            onChange={handleToChange}
            disabled={disabled}
            format="YYYY-MM-DD"
            placeholder="TODAY"
            suffixIcon={null}
            disabledDate={(current) => current && (current > dayjs().endOf('day') || (fromDate ? current < dayjs(fromDate) : false))}
          />
        </div>
      </div>
    </div>
  );
};
